module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "works_top"
  }, [_vm._m(0), _c('ul', {
    staticClass: "works_list"
  }, _vm._l((_vm.data), function(d) {
    return _c('li', {
      staticClass: "works_item"
    }, [_c('router-link', {
      staticClass: "common_link-box",
      attrs: {
        "to": '/works/' + d.slug
      }
    }, [_vm._l((d.picture), function(p) {
      return (p.id === '1') ? _c('div', {
        staticClass: "works_thumb"
      }, [_c('img', {
        attrs: {
          "src": p.path,
          "alt": "イメージ"
        }
      })]) : _vm._e()
    }), _c('h2', {
      staticClass: "works_list-title"
    }, [_vm._v(_vm._s(d.title))])], 2), _c('div', {
      staticClass: "works_list-detail"
    }, [_c('p', {
      staticClass: "works_description"
    }, [_vm._v(_vm._s(d.text))]), _c('p', {
      staticClass: "works_year"
    }, [_vm._v("制作年：" + _vm._s(d.year))])])], 1)
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "headline page_headline"
  }, [_vm._v("Works"), _c('div', {
    staticClass: "sub"
  }, [_vm._v("作品紹介")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7480d49c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorksTop.vue
// module id = 41
// module chunks = 0